import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { FormError } from '@/components/FormError'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { api } from '@/lib/api'
import type { Family } from '@/lib/families'

// A circle's name. Like everything else about a circle, anyone in it can change it. The id keeps the field's label
// pointing at the right box when the quick edit opens over the settings page.
export function CircleName({ family, id = 'rename' }: { family: Family; id?: string }) {
  const queryClient = useQueryClient()
  const [name, setName] = useState(family.name)
  const rename = useMutation({
    mutationFn: (name: string) => api(`/families/${family.id}`, { method: 'PATCH', body: { name } }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['family', family.id] })
      await queryClient.invalidateQueries({ queryKey: ['families'] })
      await queryClient.invalidateQueries({ queryKey: ['circles'] })
    },
  })
  return (
    <form
      className="grid gap-2"
      onSubmit={(e) => {
        e.preventDefault()
        rename.mutate(name.trim())
      }}
    >
      <Label htmlFor={id}>Circle name</Label>
      <div className="flex gap-2">
        <Input id={id} required maxLength={80} value={name} onChange={(e) => setName(e.target.value)} />
        <Button type="submit" variant="outline" disabled={rename.isPending || name.trim() === family.name}>
          Rename
        </Button>
      </div>
      <FormError error={rename.error} />
    </form>
  )
}
